import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from './store/index'
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
Vue.use(ElementUI);
import '@/styles/index.scss' // global css
import './permission' // permission control

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
